import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { buildUrlWithParameters } from '../../../utils/url-utils/urlUtils';
import { EmptyState } from '../../../components/empty-state/EmptyState';
import { AnimatedLink } from '../../../components/animated-link/AnimatedLink';
import { Connect, PropsFromRedux } from './NavFoldersContentContainer';
import styles from './nav_folders_content.module.scss';
import { NavDropdownTop } from '../../components/dropdown-top/NavDropdownTop';
import { NavDropdownContent } from '../../components/dropdown-content/NavDropdownContent';
import { NavDropdownFooter } from '../../components/dropdown-footer/NavDropdownFooter';

type Props = PropsFromRedux & {
  foldersStored: boolean;
};

export const RawNavFoldersContent: React.FC<Props> = ({
  foldersStored,
  folders,
}) => {
  return (
    <NavDropdownContent>
      {foldersStored && folders.length > 0 && (
        <>
          <NavDropdownTop />
          <ul>
            {folders.map((folder) => (
              <li key={folder.folderKey}>
                <Link
                  className={styles.folder}
                  title={folder.title}
                  to={buildUrlWithParameters(`/dossiers/${folder.folderKey}`, {
                    source: 'folders_dropdown_one',
                  })}
                >
                  {folder.title}
                </Link>
              </li>
            ))}
          </ul>
        </>
      )}
      {(!foldersStored || folders.length > 0) && (
        <NavDropdownFooter>
          <AnimatedLink
            component={Link}
            to={buildUrlWithParameters('/dossiers', {
              source: 'folders_dropdown_all',
            })}
          >
            <FormattedMessage id="navigation/folders/NavFoldersContent.tsx/1" />
          </AnimatedLink>
        </NavDropdownFooter>
      )}
      {foldersStored && folders.length === 0 && (
        <Link
          to={buildUrlWithParameters('/dossiers', {
            source: 'folders_dropdown_empty',
          })}
        >
          <EmptyState
            title="Aucun dossier"
            logo="/img/logo/empty_state/empty_folder.svg"
          >
            <p>
              <FormattedMessage id="navigation/folders/NavFoldersContent.tsx/2" />
            </p>
          </EmptyState>
        </Link>
      )}
    </NavDropdownContent>
  );
};

export const NavFoldersContent = Connect(RawNavFoldersContent);
